module.exports = {
  "/:accessToken": {
    "success": {
      "share page loaded": [
        "SHARE_PAGE_LOAD"
      ]
    },
    "error": [
      "SHARE_PAGE_ERROR"
    ]
  },
  "/": {
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    }
  }
};